const permissions = {
  header: 'Roles y permisos',
  notice: 'Los cambios afectarán a los usuarios con funciones coincidentes en todos los sitios de la empresa.',
  toast: {
    delete: 'La función eliminada se asignó correctamente',
    error: 'Algo salió mal',
  },
  actions: {
    save: {
      button: 'Guardar cambios',
      confirmModal: {
        title: 'Confirmación',
        content: '¿Está seguro de que desea guardar los cambios?',
        confirm: 'Confirmar',
      },
      error: 'Ocurrió un error al actualizar los permisos.',
      success: '¡Los permisos se actualizaron correctamente!',
    },
    search: {
      placeholder: 'Buscar ...',
    },

    delete: {
      deleteBtn: 'Eliminar',
    },
    history: {
      historyBtn: 'Historia',
    },
  },
  roleCard: {
    actions: {
      default: {
        label: 'Por defecto',
        title: 'Restablecer los permisos predeterminados para la función "{{ name }}"',
        text: 'Al continuar, revertirá a los permisos de función predeterminados, lo que ocasionará la pérdida de todos los ajustes que haya realizado.',
        confirm: 'Confirmar',
        success: 'Los permisos predeterminados de la función se restauraron correctamente.',
        failure: 'No se pudieron restaurar los permisos de la función debido a un error inesperado.',
      },
      delete: {
        title: 'Eliminar funciones',
        deletionEnabled: 'Está a punto de eliminar 1 función',
        deletionDisabled: 'No se puede eliminar la función con {{ count }} usuarios conectados. Elimine usuarios antes de eliminar',
      },
    },
    select: {
      all: 'Configurar todos los permisos',
      none: 'Deseleccionar todos los permisos',
    },
    count: '{{ count }} users',
  },
  addRoleCard: {
    title: 'Añadir +',
    createMode: {
      label: 'Nombre:',
    },
  },
  scope: {
    Holidays: 'Holidays',
    MissionControl: 'MissionControl',
    Timeline: 'Timeline',
    OnlineDrivers: 'Online Drivers',
    Reservations: 'Booking',
    LiveMap: 'Live Map',
    Settings: 'Settings',
    SettingsTemplates: 'Settings Templates',
    Vehicles: 'Vehicles',
    Trips: 'Trips',
    Suppliers: 'Suppliers',
    Shuttles: 'Shuttles',
    Shifts: 'Shifts',
    Services: 'Services',
    'Roles and Permissions': 'Roles and Permissions',
    Reports: 'Reports',
    Rates: 'Rates',
    Profiles: 'Profiles',
    Passengers: 'Passengers',
    Parent: 'Parent',
    Users: 'Users',
    Locations: 'Locations',
    Integrations: 'Integrations',
    Fares: 'Fares',
    ExtraServices: 'Extra Services',
    Drivers: 'Drivers',
    DriverShifts: 'Driver Shifts',
    DataUpload: 'Import',
    Export: 'Export',
    CustomRules: 'Custom Rules',
    BlacklistCards: 'Blacklist Cards',
    Automations: 'Automations',
    Attributes: 'Attributes',
    Areas: 'Areas',
  },
  sitesViewError: 'Cambie a una vista de sitio único para acceder a esta página',
};

export default permissions;
